import React, { useEffect, useState } from "react";
import { Loader2, Heart } from "lucide-react";
import { api } from "@/api";
import { useFavorites } from "@/hooks/useFavorites";
import { StickerGrid } from "@/components/StickerGrid";

export function Favorites() {
  const [stickers, setStickers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { favIds, onToggleFav } = useFavorites();

  const load = () => {
    setLoading(true);
    api
      .get("/favorites")
      .then((res) => {
        setStickers(res.data);
        try {
          localStorage.setItem("bc_fav_cache", JSON.stringify(res.data));
        } catch (e) {}
      })
      .catch(() => {
        try {
          const cached = JSON.parse(localStorage.getItem("bc_fav_cache") || "[]");
          setStickers(cached);
        } catch (e) {
          setStickers([]);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const handleToggle = (id, nowFav) => {
    onToggleFav(id, nowFav);
    if (!nowFav) setStickers((prev) => prev.filter((s) => s.id !== id));
  };

  if (loading)
    return (
      <div className="py-24 flex justify-center">
        <Loader2 className="animate-spin text-[#C58B90]" size={32} />
      </div>
    );

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Heart className="fill-[#C58B90] text-[#C58B90]" size={26} />
        <h1 className="font-serif text-3xl">Meus Favoritos</h1>
      </div>
      <StickerGrid
        stickers={stickers}
        favIds={favIds}
        onToggleFav={handleToggle}
        emptyText="Você ainda não favoritou nenhum sticker. Toque no ❤️ para salvar 💗"
      />
    </div>
  );
}
